import React from 'react';
import { Link } from 'react-router-dom';

const LeadGenerationCampaignPage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/home-banner-1.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              How to create a successful<br />
              lead generation campaign
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    <strong>What is a lead generation campaign?</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    A Lead generation campaign is the marketing efforts that help a business to generate both customers and sales. This is achieved through the process of identifying, attracting and capturing new prospects who are likely to have an interest in the product or service being promoted.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The campaign should include a strategy that will typically combine several delivery mechanisms used to create the leads and maximise opportunities. There is no standardised approach, however factors such as budget, resources, skill set, and target market are key considerations.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    <strong>The importance of lead generation campaigns</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    A lead generation campaign not only creates business growth opportunities, but it's also a process that can build brand visibility and trust. Leads can be nurtured over time, building, and forming strong relationships, moving through a structured pipeline to convert into loyal customers. A business with no lead generation campaign is essentially a recipe for disaster.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    <strong>What are the benefits?</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-4 text-lg">
                    New leads are essential to sustain and grow a business and key benefits include:
                  </p>

                  <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6 text-lg">
                    <li className="mb-2">Boost revenue & profit.</li>
                    <li className="mb-2">Increasing visibility of a brand/business.</li>
                    <li className="mb-2">Expanding your consumer market.</li>
                    <li className="mb-2">Generating positive customer reviews.</li>
                    <li className="mb-2">Creating interest towards a product/service.</li>
                  </ul>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    What is important is establishing how you are going to achieve some or all the above.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    <strong>How to create a campaign</strong>
                  </p>

                  <p className="text-gray-900 font-semibold mb-3 text-lg">Research</p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Who are you targeting, what do you know about your prospective buyers? To execute a successful campaign, it's important to research your target audience. Understanding the demographics of your market, and recognising their wants and needs, will help to form a successful strategy to increase your prospect base.
                  </p>

                  <p className="text-gray-900 font-semibold mb-3 text-lg">Campaign objectives</p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Setting clear campaign objectives and goals will help to establish the purpose of running your campaign and achieve the outcome you envisage. Typical objectives include generating a certain number of leads, obtaining subscribers or registrants, sales increase etc. Every campaign is a learning experience and can differ greatly, so identifying and determining measurable goals is key to driving success.
                  </p>

                  <p className="text-gray-900 font-semibold mb-3 text-lg">Establishing your campaign</p>

                  <p className="text-gray-700 leading-relaxed mb-4 text-lg">
                    Aligning your goals and objectives with the target audience in mind is crucial to the success of your campaign. Marketing will typically include a mix of online or offline lead generation channels widely used by businesses, including:
                  </p>

                  <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6 text-lg">
                    <li className="mb-2">Direct mail</li>
                    <li className="mb-2">Blog posts</li>
                    <li className="mb-2">Email campaigns</li>
                    <li className="mb-2">Social media marketing</li>
                    <li className="mb-2">PPC/SEO campaigns</li>
                    <li className="mb-2">Inserts/door drops</li>
                  </ul>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Channel selection should be relevant to the target audience, ensuring the campaign is measurable to gather key insight and learnings.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The next step is to establish a CTA and design the content to reflect this. How would you like your audience to respond and how can you achieve this? Response examples include form fill, quote request, coupon/discount, purchase a product/service etc. Thinking about who your target audience is will help in deciding the most effective response mechanism.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Testing is vital to any campaign success, whether it's creative, message, CTA, data, channel etc. Building in a test phase within your campaign strategy will help you learn more about your audience, how and what they respond to, and allow you to optimise your marketing efforts in future campaigns.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    <strong>Ongoing communication strategy</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Developing a communication strategy to respond to leads is fundamental to maintaining and growing your customers. How will you follow up to responders, how do you attract those who didn't respond initially, how do you engage moving down the sales pipeline? These are just a few of the considerations and challenges that need to be built into an ongoing strategy. An effective communications strategy can help transform a business into a brand, subsequently developing and maintaining a long term relationship with customers.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    At Lloyd James we understand that lead generation campaigns are an essential part of business growth and customer acquisition. To find out how we use our expertise and knowledge to create and build a campaign that works for you <Link to="/contact" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>click here</Link> to get in touch.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LeadGenerationCampaignPage;